import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import ChevronUp16 from '@carbon/icons-react/es/chevron--up/16';
import { Checkbox } from 'antd';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { LinkButton } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import { Input, TextArea } from 'components/atoms/input';
import { Divider as DividerAtom } from 'components/molecules/action-panel/components';
import { useTranslation } from 'hooks/use-translation';

const Divider = styled(DividerAtom)`
  margin: 0 !important;
`;

export const CheckboxItem = styled.div`
  display: flex;
  gap: var(--spacing-04);
`;

export const AdvancedOptionsMenu = styled.div`
  display: flex;
  gap: var(--spacing-05);
  margin-top: 1rem;
  flex-direction: column;
`;

export const HorizontalFormItem = styled(Form.Item)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin-bottom: 0;

  .ant-form-item-control-input-content {
    display: flex;
  }
`;

export const HorizontalFormItemLabel = styled.p`
  margin-left: var(--spacing-02);
  margin-bottom: 0%;
`;

const StyledLinkButton = styled(LinkButton)`
  &:hover,
  &:active,
  &:focus {
    color: var(--blue-60) !important;
    text-decoration: none;
  }
`;

export const EventForm = ({ form, objectType, field }) => {
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(true);

  const advancedOptions = [
    'captureKeyIntervalForFirstActivityOnly',
    'allowAdminsAndOwnersToEdit',
  ];

  const getInitialValues = (f) => {
    if (f) {
      const { fieldName, fieldLabel, description, metaData } = f;

      return {
        fieldName,
        fieldLabel,
        description,
        ...metaData,
      };
    }

    return {
      fieldName: '',
      fieldLabel: '',
      description: '',
      objectType,
      fieldType: 'KEY_EVENTS',
      fieldDataType: 'DATE',
      captureKeyIntervalForFirstActivityOnly: true,
      allowAdminsAndOwnersToEdit: true,
    };
  };

  const initialValues = getInitialValues(field);
  const requiredMessage = useTranslation('input.required');

  const handleValuesChange = async () => {
    await form.validateFields();
  };

  return (
    <Form
      form={form}
      name="new_event_form"
      autoComplete="off"
      layout="vertical"
      initialValues={initialValues}
      onValuesChange={handleValuesChange}
    >
      <Form.Item
        name="fieldLabel"
        label="Name of the key event"
        rules={[{ required: true, message: requiredMessage }]}
      >
        <Input
          name="fieldLabel"
          autoFocus
          id="add-key-event.name"
          data-cy="add-key-event.name"
        />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <TextArea
          autoSize={{ minRows: 3, maxRows: 3 }}
          data-cy="add-key-event.desc"
        />
      </Form.Item>
      <Divider />

      <AdvancedOptionsMenu>
        <StyledLinkButton
          onClick={() => {
            setShowAdvancedOptions(!showAdvancedOptions);
          }}
          icon={
            showAdvancedOptions ? (
              <ChevronUp16 color="#0F62FE" />
            ) : (
              <ChevronDown16 color="#0F62FE" />
            )
          }
        >
          <FormattedMessage id="settings.events.advanced_options" />
        </StyledLinkButton>
        {showAdvancedOptions && (
          <>
            {advancedOptions.map((option) => (
              <HorizontalFormItem name={option}>
                <Checkbox
                  data-cy={`add-key-event.advanced.${option}`}
                  defaultChecked={initialValues[option]}
                  onChange={() => {
                    form.setFieldsValue({
                      ...form.getFieldsValue(),
                      [option]: !form.getFieldValue(option),
                    });
                  }}
                />
                <HorizontalFormItemLabel>
                  <FormattedMessage
                    id={`settings.events.advanced_options.${option}`}
                  />
                </HorizontalFormItemLabel>
              </HorizontalFormItem>
            ))}
          </>
        )}
      </AdvancedOptionsMenu>
    </Form>
  );
};
